module.exports = __webpack_public_path__ + "img/5.27af2d60.png";